import React from "react";
import { Briefcase, BarChart, Globe, Cpu, FileText } from "lucide-react";

const services = [
  {
    id: 1,
    icon: <Globe size={32} className="text-[#4FB1FF]" />,
    title: "Global Business Matchmaking",
    subtitle: "Building Bridges Between Markets",
    description:
      "Connecting investors, corporations, and institutions across India and Europe through curated relationships.",
    image: "/Images/image23.jpeg",
  },
  {
    id: 2,
    icon: <BarChart size={32} className="text-[#4FB1FF]" />,
    title: "Market Intelligence & Research",
    subtitle: "Turning Data into Strategic Advantage",
    description:
      "Providing market insights and economic analysis to empower businesses with data-driven strategies.",
    image: "/Images/image22.jpeg",
  },
  {
    id: 3,
    icon: <Briefcase size={32} className="text-[#4FB1FF]" />,
    title: "Strategic Expansion Support",
    subtitle: "Your Gateway to Indo European Markets",
    description:
      "Hands-on assistance for international expansion, trade missions, and stakeholder introductions.",
    image: "/Images/image9.jpeg",
  },
  {
    id: 4,
    icon: <Cpu size={32} className="text-[#4FB1FF]" />,
    title: "Digital Transformation",
    subtitle: "Driving Future-Ready Business Models",
    description:
      "Helping members adopt digital-first strategies with e-commerce, AI, and sustainability solutions.",
    image: "/Images/image10.jpeg",
  },
  {
    id: 5,
    icon: <FileText size={32} className="text-[#4FB1FF]" />,
    title: "Policy Advocacy",
    subtitle: "Giving Voice to Business Needs",
    description:
      "Engaging with ministries and trade bodies to advocate for innovation-led growth and ease of doing business.",
    image: "/Images/image11.jpeg",
  },
];

const ServicesSection = () => {
  return (
    <section className="bg-[#F7FAFF] py-20 px-6">
      <div className="container mx-auto max-w-7xl text-center">
        {/* Section Header */}
        <h5 className="text-[#4FB1FF] uppercase font-bold font-Agatho_Regular tracking-wide mb-3">
          Our Services
        </h5>
        <h1 className="text-5xl md:text-6xl font-Agatho_Regular  font-extrabold text-[#0B1D33] mb-6">
          Enabling Growth Through Insight & Strategy
        </h1>
        <p className="text-gray-600 max-w-3xl mx-auto mb-16 leading-relaxed text-xl  font-Agatho_Regular font-bold">
          <span className="font-extrabold">Indo European Business Council</span> empowers businesses to thrive globally
     
          through strategic matchmaking, actionable insights, and seamless
          cross-border collaboration.
        </p>
   

        {/* Services Grid */}
        <div className="flex flex-wrap justify-center gap-12">
          {services.map((service) => (
            <div
              key={service.id}
              className="relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition p-8 flex flex-col justify-between w-full sm:w-[45%] lg:w-[30%] min-h-[480px]"
            >
              {/* Icon */}
              <div className="absolute -top-6 left-8 bg-white rounded-full shadow-md p-3 flex items-center justify-center transition-transform duration-300 hover:scale-110">
                {service.icon}
              </div>

              {/* Service Image */}
              <div className="w-full h-40 bg-gray-100 rounded-xl mb-4 flex items-center justify-center overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="object-cover w-full h-full rounded-xl"
                  style={{ objectPosition: "center" }}
                />
              </div>

              {/* Content */}
              <div className="pt-2 flex flex-col flex-grow">
                <h3 className="text-2xl md:text-3xl font-Agatho_Regular font-bold text-[#0B1D33] mb-2">
                  {service.title}
                </h3>
                <h4 className="text-sm md:text-base  text-[#4FB1FF] font-medium mb-3">
                  {service.subtitle}
                </h4>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6 flex-grow">
                  {service.description}
                </p>
               
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
